import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Container, Row, Col } from 'react-grid-system';
import { Helmet } from 'react-helmet';
import H1 from '../../../atoms/title/H1';
import { FilterTableHeader } from '../../../molecules/copyright-checker/FilterTableHeader';
import Notice from '../../../molecules/Notice';
import PaginationList from '../../../molecules/PaginationList';
import { CopyrightCheckerDossierOverviewTable } from '../../../organisms/table/CopyrightCheckerDossierOverviewTable';
import Layout from '../../../templates/Layout';
import { useTranslation } from 'react-i18next';
export const CopyrightCheckerDossiersOverviewView = ({ notice, handleFilter, filterState, availableStatuses, loading, data, resData, setPage, }) => {
    const { t } = useTranslation();
    return (_jsxs(Layout, { children: [_jsx(Helmet, { children: _jsx("title", { children: t('copyright_checker.overview.title') }) }), notice && (_jsx(Notice, { type: notice.type, text: notice.text, title: notice.title })), _jsx(H1, { "data-testid": "title", children: t('copyright_checker.overview.title') }), _jsxs(Container, { style: { padding: 0 }, children: [_jsx(Row, { children: _jsx(Col, { sm: 12, children: _jsx(FilterTableHeader, { onSubmit: handleFilter, values: filterState, options: {
                                    sources: [
                                        {
                                            label: t('copyright_checker.filters.source.options.not_ignored'),
                                            value: 0,
                                        },
                                        {
                                            label: t('copyright_checker.filters.source.options.ignored'),
                                            value: 1,
                                        },
                                    ],
                                    statuses: availableStatuses.map(s => {
                                        return {
                                            label: t(`copyright_checker.dossier.statuses.${s}`),
                                            value: s,
                                        };
                                    }),
                                } }) }) }), _jsx(Row, { children: _jsxs(Col, { sm: 12, children: [_jsx(CopyrightCheckerDossierOverviewTable, { loading: loading, data: data }), _jsx(PaginationList, { disabled: loading, links: resData.links, setPage: setPage })] }) })] })] }));
};
